// extracted by mini-css-extract-plugin
export default {"ring":"progressRing_ring__JHxWc","track":"progressRing_track__7EXOq","fill":"progressRing_fill__CwB2o","label":"progressRing_label__0p-3j"};